import React from 'react';
import PropTypes from 'prop-types';
import classnamesBind from 'classnames/bind';
import Icon from '@concur/nui-widgets/lib/Icon/Icon';
import withNuiFormatter from '../utils/withNuiFormatter';

const getProfileName = ({
    actingAs,
    formatter,
    fullName,
}) => {
    const { allUsers, companyName, otherUserName } = actingAs;

    if (companyName) {
        return companyName;
    }
    if (allUsers) {
        return formatter.formattedMessage({ id: 'CoreUI.allMyUsers' });
    }
    if (otherUserName) {
        return otherUserName;
    }
    return fullName;
};

export const getProfileDisplayText = ({
    actingAs,
    formatter,
    fullName,
    shortNames = false,
}) => {
    const { companyName } = actingAs;

    const name = getProfileName({ actingAs, formatter, fullName });

    if (companyName) {
        return formatter.formattedMessage({ id: 'CoreUI.administeringCompany', values: { 0: companyName } });
    }
    return shortNames
        ? formatter.formattedMessage({ id: 'CoreUI.actingAs', values: { 0: name } })
        : formatter.formattedMessage({ id: 'CoreUI.currentlyActingAs', values: { 0: name } });
};

const ProfileIdentifier = ({
    actingAs,
    classNameMap,
    cssBlock,
    formatter,
    fullName,
}) => {
    const classnames = classnamesBind.bind(classNameMap);

    const { allUsers, companyName, otherUserName } = actingAs;
    const isActingForOthers = !!(allUsers || companyName || otherUserName);

    const iconClassName = classnames(`${cssBlock}__icon`, {
        [`${cssBlock}__icon--admin`]: isActingForOthers,
    });

    return (
        <div className={classnames(`${cssBlock}__identifier`)} data-test="identifier">
            <Icon
                ariaHidden
                className={iconClassName}
                iconName={isActingForOthers ? 'user-admin' : 'user'}
                size="md"
            />

            <div className={classnames(`${cssBlock}__name`)}>
                {isActingForOthers
                    ? (
                        <div className={classnames(`${cssBlock}__description`)}>
                            {getProfileDisplayText({ actingAs, formatter, fullName })}
                        </div>
                    )
                    : fullName}
            </div>
        </div>
    );
};

ProfileIdentifier.displayName = 'ProfileIdentifier';

ProfileIdentifier.propTypes = {
    actingAs: PropTypes.shape({
        allUsers: PropTypes.bool,
        companyName: PropTypes.string,
        otherUserName: PropTypes.string,
    }),
    cssBlock: PropTypes.string,
    fullName: PropTypes.string,
};

export default withNuiFormatter(ProfileIdentifier);
